import * as React from "react"
import "./style_8.scss"

export default function ProductContentStyle8({ items }) {
    return (items?.map((data, index) => !!Object.keys(data)?.length && (
        <div key={index}
            className={`product-content style_8`}
        >
            {data?.url_path && (
                <div className={`content-block-info`}>
                    <a target="_blank" rel="noreferrer" href={data.url_path} className="title">{data.title}</a>
                    <img src={data.image} alt="" />
                </div>
            )}
        </div>
    ))
    )
}
